<template>
    <div class="o-layout o-layout--center">
        <div class="c-panel">

            <div class="c-logo margin-b-40">
                <img src="/img/logo/logo-text.svg" width="126" height="40">
            </div>

            <h2 class="margin-b-24">Log in bij SIGV</h2>

            <c-form ref="form" @valid="submit" :autocomplete="'off'">

                <c-form-element
                    :label="'E-mailadres'">
                    <input type="email" v-model="email" required name="email" autocomplete="email" />
                </c-form-element>

                <c-form-element
                    :label="'Wachtwoord'"
                    :icon="true"
                    :password="true"
                    @password="hidePassword">
                    <input
                        :type="passwordHidden ? 'password': 'text'"
                        v-model="password" required name="password" autocomplete="current-password" />
                </c-form-element>

                <p class="color-alert" v-if="error">Deze combinatie van e-mailadres en wachtwoord is niet geldig.</p>

                <button type="submit" class="c-btn c-btn--expanded margin-t-32" ref="submit">Inloggen</button>

                <div class="text-center">
                    <router-link :to="{name: 'password-forget'}">Wachtwoord vergeten</router-link>
                </div>
            </c-form>

        </div>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import Page from '@classes/Page';

export default {
    mixins: [ Form ],
    data() {
        return {
            error: false,
            email: '',
            password: '',
            passwordHidden: true
        }
    },
    methods: {
        hidePassword(show) {
            this.passwordHidden = !show;
        },
        submit() {
            this.error = false;

            this.$store.dispatch('user/login', {
                email: this.email,
                password: this.password
            }).then( (user) => {
                this.$router.push(Page.authenticatorRoute(user));
            }).catch( (e) => {
                console.log(e);
                this.error = true;
            })
        }
    }
}
</script>
